import React from "react";

function IconLocation(data) {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={data.w}
          height={data.h}
          viewBox="0 0 28 40"
        >
          <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
            <g fillRule="nonzero" transform="translate(-432 -114)">
              <g transform="translate(432.4 114)">
                <g>
                  <path
                    fill="#ff8400"
                    d="M0 39.9813321L0 37.7038463 26.3055553 37.7038463 26.3055553 40z"
                  ></path>
                  <path
                    fill="#3D3833"
                    d="M13.75 34.4l-.728-.43c-.318-.224-7.585-5.75-9.865-9.726C-.785 18.42-1.196 8.787 4.41 3.747A12.86 12.86 0 0114.07.013a13.588 13.588 0 018.948 3.734c5.605 4.947 5.157 14.58 1.14 20.423-2.205 3.901-9.528 9.427-9.827 9.65l-.58.58zm-.41-32.165a11.046 11.046 0 00-7.343 3.061c-4.372 3.883-4.764 12.078-.953 17.66 1.72 3.024 6.838 7.28 8.707 8.643 1.868-1.437 6.95-5.6 8.612-8.53 3.887-5.601 3.475-13.871-.803-17.66a11.7 11.7 0 00-7.473-3.118l-.747-.056z"
                  ></path>
                  <ellipse
                    cx="13.788"
                    cy="14.873"
                    fill="#ff8400"
                    rx="4.353"
                    ry="4.35"
                  ></ellipse>
                </g>
              </g>
            </g>
          </g>
        </svg>
    );
  }

export default IconLocation;
